export interface Category {
  name: string;
  nameEn: string;
  url: string;
  icon: string;
  imageSeq: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    name: 'Buty',
    nameEn: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    imageSeq: 'cat-shoes-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=stylish%20white%20sneakers%20on%20clean%20minimal%20cream%20surface%20with%20soft%20natural%20lighting%2C%20product%20photography%2C%20warm%20neutral%20aesthetic%2C%20gentle%20shadows%2C%20minimalist%20european%20catalog%20style%2C%20editorial%20fashion%20photography%20with%20clean%20composition&width=600&height=400&seq=cat-grid-shoes-v2&orientation=landscape',
  },
  {
    name: 'Bluzy/Swetry',
    nameEn: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageSeq: 'cat-hoodies-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=cozy%20oversized%20beige%20hoodie%20folded%20neatly%20on%20light%20wooden%20surface%2C%20soft%20morning%20light%20from%20window%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20colors%2C%20clean%20aesthetic%2C%20gentle%20shadows%2C%20scandinavian%20style%20catalog%20photography%20with%20organic%20texture&width=600&height=400&seq=cat-grid-hoodies-v2&orientation=landscape',
  },
  {
    name: 'Koszulki',
    nameEn: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    imageSeq: 'cat-tshirts-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=high%20quality%20white%20cotton%20t-shirt%20on%20minimal%20hanger%20against%20soft%20pastel%20background%2C%20clean%20editorial%20product%20photography%2C%20gentle%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20minimalist%20scandinavian%20style%2C%20soft%20shadows%20and%20organic%20composition&width=600&height=400&seq=cat-grid-tshirts-v2&orientation=landscape',
  },
  {
    name: 'Kurtki',
    nameEn: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-cloudy-line',
    imageSeq: 'cat-jackets-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=stylish%20lightweight%20beige%20jacket%20on%20minimal%20display%2C%20soft%20natural%20lighting%2C%20product%20photography%20with%20gentle%20shadows%2C%20warm%20cream%20background%2C%20minimalist%20editorial%20style%2C%20clean%20composition%20with%20subtle%20texture&width=600&height=400&seq=cat-grid-jackets-v2&orientation=landscape',
  },
  {
    name: 'Spodnie/Szorty',
    nameEn: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-tools-line',
    imageSeq: 'cat-pants-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=neatly%20folded%20beige%20chino%20pants%20on%20clean%20wooden%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20scandinavian%20catalog%20aesthetic%2C%20gentle%20shadows%20and%20clean%20composition&width=600&height=400&seq=cat-grid-pants-v2&orientation=landscape',
  },
  {
    name: 'Nakrycia głowy',
    nameEn: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-customer-service-2-line',
    imageSeq: 'cat-headwear-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=stylish%20cream%20beige%20baseball%20cap%20on%20minimal%20surface%2C%20soft%20natural%20lighting%2C%20product%20photography%2C%20warm%20neutral%20aesthetic%2C%20clean%20minimalist%20editorial%20style%2C%20gentle%20shadows%20and%20simple%20composition&width=600&height=400&seq=cat-grid-headwear-v2&orientation=landscape',
  },
  {
    name: 'Zestawy',
    nameEn: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    imageSeq: 'cat-sets-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=matching%20beige%20hoodie%20and%20sweatpants%20set%20neatly%20folded%20on%20clean%20cream%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20editorial%20catalog%20style%20with%20harmonious%20composition&width=600&height=400&seq=cat-grid-sets-v2&orientation=landscape',
  },
  {
    name: 'Bielizna',
    nameEn: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-vip-crown-line',
    imageSeq: 'cat-underwear-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=neatly%20folded%20white%20cotton%20underwear%20on%20clean%20cream%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20clean%20aesthetic%2C%20warm%20tones%2C%20gentle%20shadows%2C%20editorial%20style&width=600&height=400&seq=cat-grid-underwear-v2&orientation=landscape',
  },
  {
    name: 'Koszulki sportowe',
    nameEn: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-basketball-line',
    imageSeq: 'cat-jersey-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=sports%20jersey%20on%20minimal%20display%2C%20soft%20natural%20lighting%2C%20product%20photography%2C%20clean%20aesthetic%2C%20warm%20neutral%20background%2C%20editorial%20sports%20photography%20style%20with%20subtle%20texture&width=600&height=400&seq=cat-grid-jersey-v2&orientation=landscape',
  },
  {
    name: 'Akcesoria',
    nameEn: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-handbag-line',
    imageSeq: 'cat-accessories-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=stylish%20gold%20tone%20minimalist%20jewelry%20necklace%20and%20watch%20on%20cream%20surface%2C%20soft%20natural%20lighting%2C%20product%20photography%2C%20warm%20neutral%20aesthetic%2C%20clean%20editorial%20style%2C%20gentle%20shadows&width=600&height=400&seq=cat-grid-accessories-v2&orientation=landscape',
  },
  {
    name: 'Torby',
    nameEn: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-shopping-bag-3-line',
    imageSeq: 'cat-bags-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=stylish%20minimal%20beige%20tote%20bag%20on%20clean%20cream%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20editorial%20catalog%20style%2C%20gentle%20shadows%20and%20clean%20composition&width=600&height=400&seq=cat-grid-bags-v2&orientation=landscape',
  },
  {
    name: 'Paski',
    nameEn: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-archive-line',
    imageSeq: 'cat-belts-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=genuine%20leather%20belt%20elegantly%20rolled%20on%20clean%20cream%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20editorial%20style%2C%20gentle%20shadows%20and%20refined%20composition&width=600&height=400&seq=cat-grid-belts-v2&orientation=landscape',
  },
  {
    name: 'Perfumy',
    nameEn: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-contrast-drop-line',
    imageSeq: 'cat-perfumes-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=elegant%20glass%20perfume%20bottle%20on%20minimal%20cream%20surface%2C%20soft%20natural%20lighting%2C%20product%20photography%2C%20warm%20neutral%20aesthetic%2C%20clean%20editorial%20style%2C%20gentle%20shadows%2C%20refined%20composition%20with%20subtle%20sparkle&width=600&height=400&seq=cat-grid-perfumes-v2&orientation=landscape',
  },
  {
    name: 'Inne',
    nameEn: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    imageSeq: 'cat-other-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=lifestyle%20product%20flatlay%20with%20minimal%20phone%20case%20wallet%20and%20sunglasses%20on%20cream%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20aesthetic%2C%20warm%20neutral%20tones%2C%20clean%20editorial%20composition%20with%20gentle%20shadows&width=600&height=400&seq=cat-grid-other-v2&orientation=landscape',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';

export const testimonialData = [
  {
    name: 'Marek K.',
    role: 'Entuzjasta sneakersów',
    rating: 5,
    title: 'Najlepsza baza w Polsce',
    text: 'Korzystam z Kakobuy Spreadsheet od ponad 6 miesięcy i jestem zachwycony. Produkty są zawsze aktualne, a opisy bardzo dokładne. Dzięki tej bazie zaoszczędziłem już setki złotych na zakupach. Polecam każdemu, kto poważnie podchodzi do zakupów z chińskich platform.',
    avatar: 'MK',
  },
  {
    name: 'Anna W.',
    role: 'Blogerka modowa',
    rating: 5,
    title: 'Codzienna inspiracja',
    text: 'Jako blogerka modowa potrzebuję stałego dostępu do świeżych trendów. Kakobuy Finds to moje główne źródło inspiracji — znajduję tu ubrania i akcesoria, które potem trafiają na mojego bloga. Baza jest przejrzysta, a kategorie świetnie zorganizowane.',
    avatar: 'AW',
  },
  {
    name: 'Piotr S.',
    role: 'Student & reseller',
    rating: 5,
    title: 'Oszczędność czasu i pieniędzy',
    text: 'Zarabiam na resellingu i Kakobuy Sheet to dla mnie narzędzie niezbędne. Codziennie sprawdzam nowe produkty i porównuję ceny. Dzięki tej bazie moje zyski wzrosły o 40%. Świetna sprawa dla każdego, kto chce zarabiać na odsprzedaży.',
    avatar: 'PS',
  },
  {
    name: 'Katarzyna L.',
    role: 'Miłośniczka mody',
    rating: 5,
    title: 'Wszystko w jednym miejscu',
    text: 'Uwielbiam to, że nie muszę już przeszukiwać dziesiątek stron. Wszystkie kategorie od butów po perfumy są w jednym miejscu. Kakobuy Spreadsheet to prawdziwy game-changer dla osób, które cenią swój czas i lubią dobre okazje.',
    avatar: 'KL',
  },
  {
    name: 'Tomasz R.',
    role: 'Przedsiębiorca e-commerce',
    rating: 4,
    title: 'Solidne narzędzie biznesowe',
    text: 'Prowadzę sklep internetowy i Kakobuy Sheet pomaga mi śledzić trendy oraz znajdować produkty z potencjałem sprzedażowym. Baza jest regularnie aktualizowana, co jest kluczowe w dynamicznie zmieniającym się świecie mody i elektroniki.',
    avatar: 'TR',
  },
  {
    name: 'Natalia M.',
    role: 'Studentka',
    rating: 5,
    title: 'Idealne dla początkujących',
    text: 'Zaczynałam od zera — nie miałam pojęcia jak zamawiać produkty z Chin. Przewodniki i opisy w Kakobuy Spreadsheet przeprowadziły mnie przez cały proces krok po kroku. Teraz zamawiam regularnie i zawsze trafiam na świetne okazje.',
    avatar: 'NM',
  },
];